export const SNIPPET_SOURCE_CODE_RETENTION_DAYS_ERROR = 'Snippet source code retention must be between 1 and 30 days';
